"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributionHost = exports.getLocalHostBasedOnApplication = exports.ADSDK_PRODUCTION_HOST = exports.ADSDK_STAGING_HOST = exports.ADSDK_DEVELOPMENT_HOST = void 0;
const types_1 = require("../tracking/types");
const environment_types_1 = require("../types/environment.types");
exports.ADSDK_DEVELOPMENT_HOST = 'https://nolan.wetransferalpha.net';
exports.ADSDK_STAGING_HOST = 'https://nolan.wetransferbeta.net';
exports.ADSDK_PRODUCTION_HOST = 'https://nolan.wetransfer.net';
/**
 * Gets the local host based on the application
 * @param applicationName adtech applicaiton name
 * @returns the local host path
 */
const getLocalHostBasedOnApplication = (applicationName) => {
    if (applicationName === types_1.AdtechApplication.mobileWeb) {
        return 'http://localhost:4206';
    }
    return 'http://localhost:4202';
};
exports.getLocalHostBasedOnApplication = getLocalHostBasedOnApplication;
/**
 * Gets the distribution host based on the environment and the application
 *
 * @param environmentName the environment name
 * @param applicationName the application name
 *
 * @returns the distribution host path
 */
const getDistributionHost = (environmentName, applicationName) => {
    const envToDistributiionUrlMap = {
        [environment_types_1.EnvironmentName.Local]: (0, exports.getLocalHostBasedOnApplication)(applicationName),
        [environment_types_1.EnvironmentName.Development]: exports.ADSDK_DEVELOPMENT_HOST,
        [environment_types_1.EnvironmentName.Staging]: exports.ADSDK_STAGING_HOST,
        [environment_types_1.EnvironmentName.Production]: exports.ADSDK_PRODUCTION_HOST,
    };
    const host = envToDistributiionUrlMap[environmentName];
    if (!host) {
        throw new Error(`No host found for environment ${environmentName}`);
    }
    return host;
};
exports.getDistributionHost = getDistributionHost;
//# sourceMappingURL=get-distribution-host.js.map